import { ValidatorFn, AbstractControl, ValidationErrors, Validators } from '@angular/forms';
import isEmail from 'validator/es/lib/isEmail';
import { ALPHA, ALPHA_WITH_SPACE } from './validation-patterns.const';
import { Validations } from './validations';
import { InputValidationNumbers } from './inputValidationNumbers.const';

export const CustomEmailValidator = () => Validator(isEmail, 'email');

export const AlphaValidator = (withSpace = true) =>
  RegexValidator(new RegExp(withSpace ? ALPHA_WITH_SPACE : ALPHA), 'alpha');

export const GroupValidator =
  (firstControlName: string, secondControlName: string, isValidFn: (firstControlValue: string, secondControlValue: string) => boolean, error: string) =>
  (group: AbstractControl): ValidationErrors | null => {
    const firstControlValue = group.get([firstControlName])?.value;
    const secondControlValue = group.get([secondControlName])?.value;
    const forbidden = !isValidFn(firstControlValue, secondControlValue);
    return forbidden ? { [error]: { value: `${firstControlValue} - ${secondControlValue}` } } : null;
  };

const Validator =
  (validatorFn: (...args: any[]) => boolean, error: string): ValidatorFn =>
  (abstractControl: AbstractControl): ValidationErrors | null => {
    const forbidden = !validatorFn(abstractControl.value ? abstractControl.value : '');
    return forbidden ? { [error]: { value: abstractControl.value } } : null;
  };

const RegexValidator = (regex: RegExp, error: string): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }
    const valid = regex.test(control.value);
    return valid ? null : { [error]: { value: control.value } };
  };
};

export const PhoneWrapperValidator = () => (control: AbstractControl) => {
  const minlength = InputValidationNumbers.inputPhoneMin;
  const maxlength = InputValidationNumbers.inputPhoneMax;
  const prefix = control.get('prefix')?.value;
  const phone = control.get('phone')?.value;
  const phoneWrapper = `${prefix}${phone}`;

  if (phoneWrapper.length < minlength) {
    return { [Validations.minlength]: { requiredLength: minlength } };
  } else if (phoneWrapper.length > maxlength) {
    return { [Validations.maxlength]: { requiredLength: maxlength } };
  }

  return null;
};

export const EqualValuesValidator = (controlName1: string, controlName2: string) => (control: AbstractControl) => {
  const value1 = control.get(controlName1)?.value;
  const value2 = control.get(controlName2)?.value;

  if (value1 === value2) {
    return null;
  }

  return { valuesNotEqual: true };
};

export const fullNameTrimValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const value = control.value as string;

  if (!value) return null;

  const startsOrEndsWithSpace = value.startsWith(' ') || value.endsWith(' ');
  const invalidCharacters = !/^[a-zA-Z0-9'’-]+(?: [a-zA-Z0-9'’-]+)*$/.test(value);

  if (startsOrEndsWithSpace) {
    return { fullNameTrim: true };
  }

  if (invalidCharacters) {
    return { fullNameInvalidChars: true };
  }

  return null;
};
